import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import Landing from './pages/Landing';
import Home from './pages/Home';
import Product from './pages/Product';
import Publishers from './pages/Publishers';
import Advertisers from './pages/Advertisers';
import LoginForm from './components/LoginForm';
import SignUp from './pages/SignUp';
import Documentation from './pages/Documentation';
import CampaignsPage from './pages/CampaignsPage';
import AdStrategist from './pages/AdStrategist';
import AnalyticsDashboard from './pages/AnalyticsDashboard';
import PublisherDashboard from './pages/PublisherDashboard';
import PublisherAnalytics from './pages/PublisherAnalytics';
import PublisherSettings from './pages/PublisherSettings';
import Playground from './pages/Playground';
import AnalyticsRouter from './components/AnalyticsRouter';

function App() {
  return (
    <AuthProvider>
      <Router>
        <AnalyticsRouter />
        <Routes>
          <Route path="/" element={<Layout><Landing /></Layout>} />
          <Route path="/home" element={<Layout><Home /></Layout>} />
          <Route path="/product" element={<Layout><Product /></Layout>} />
          <Route path="/publishers" element={<Layout><Publishers /></Layout>} />
          <Route path="/advertisers" element={<Layout><Advertisers /></Layout>} />
          <Route path="/playground" element={<Layout><Playground /></Layout>} />
          <Route path="/login" element={<Layout><LoginForm /></Layout>} />
          <Route path="/signup" element={<Layout><SignUp /></Layout>} />
          <Route path="/documentation" element={<Layout><Documentation /></Layout>} />
          <Route path="/campaigns" element={<Layout><CampaignsPage /></Layout>} />
          <Route path="/ad-strategist" element={<Layout><AdStrategist /></Layout>} />
          <Route path="/analytics" element={<Layout><AnalyticsDashboard /></Layout>} />
          <Route path="/publisher-dashboard" element={<Layout><PublisherDashboard /></Layout>} />
          <Route path="/publisher-analytics" element={<Layout><PublisherAnalytics /></Layout>} />
          <Route path="/publisher-settings" element={<Layout><PublisherSettings /></Layout>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App; 